export default __webpack_public_path__ + "b512cedd88519576691a6c1290be4b87.png";